import React, { memo } from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Clock, Star, Heart } from './Icons';
export function MesaVivaSection() {
  return <section className="py-24 bg-warm-white relative overflow-hidden" data-id="element-243">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-sand rounded-full mix-blend-multiply filter blur-3xl opacity-50 transform translate-x-1/2 -translate-y-1/2" data-id="element-244"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gold rounded-full mix-blend-multiply filter blur-3xl opacity-10 transform -translate-x-1/2 translate-y-1/2" data-id="element-245"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-246">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-247">
          <FadeIn data-id="element-248">
            <p className="text-terracotta font-medium tracking-wide uppercase text-sm mb-4" data-id="element-249">
              La Diferencia
            </p>
            <h2 className="text-4xl md:text-5xl font-serif text-deep-brown mb-8 relative inline-block" data-id="element-250">
              El Efecto Mesa Viva
              <div className="absolute -bottom-3 left-1/4 right-1/4 h-[2px] bg-gold" data-id="element-251"></div>
            </h2>
            <p className="text-xl text-brown-medium leading-relaxed mt-8" data-id="element-252">
              Existe una diferencia que se nota antes de probar el primer
              bocado. Hay algo que los eventos realmente memorables tienen en
              común:{' '}
              <span className="text-deep-brown font-medium" data-id="element-253">
                Una mesa que se ve trabajada.
              </span>
            </p>
          </FadeIn>
        </div>

        <StaggerContainer className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-254">
          <StaggerItem data-id="element-255">
            <div className="bg-cream p-8 rounded-sm border border-sand/50 h-full hover:shadow-md transition-shadow duration-300 group" data-id="element-256">
              <div className="w-14 h-14 bg-linen rounded-full flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors" data-id="element-257">
                <Clock className="text-gold" size={28} data-id="element-258" />
              </div>
              <h3 className="text-xl font-serif text-deep-brown mb-4" data-id="element-259">
                Elaboración del Día
              </h3>
              <p className="text-brown-medium leading-relaxed" data-id="element-260">
                Productos que claramente fueron elaborados ese mismo día.
                Frescura absoluta que se percibe en las texturas y los aromas.
              </p>
            </div>
          </StaggerItem>

          <StaggerItem data-id="element-261">
            <div className="bg-cream p-8 rounded-sm border border-sand/50 h-full hover:shadow-md transition-shadow duration-300 group" data-id="element-262">
              <div className="w-14 h-14 bg-linen rounded-full flex items-center justify-center mb-6 group-hover:bg-terracotta/20 transition-colors" data-id="element-263">
                <Star className="text-terracotta" size={28} data-id="element-264" />
              </div>
              <h3 className="text-xl font-serif text-deep-brown mb-4" data-id="element-265">
                Formatos Únicos
              </h3>
              <p className="text-brown-medium leading-relaxed" data-id="element-266">
                Formatos que no se consiguen en ningún supermercado. Diseñados
                específicamente para destacar en su evento.
              </p>
            </div>
          </StaggerItem>

          <StaggerItem data-id="element-267">
            <div className="bg-cream p-8 rounded-sm border border-sand/50 h-full hover:shadow-md transition-shadow duration-300 group" data-id="element-268">
              <div className="w-14 h-14 bg-linen rounded-full flex items-center justify-center mb-6 group-hover:bg-olive/20 transition-colors" data-id="element-269">
                <Heart className="text-olive" size={28} data-id="element-270" />
              </div>
              <h3 className="text-xl font-serif text-deep-brown mb-4" data-id="element-271">
                Hospitalidad Real
              </h3>
              <p className="text-brown-medium leading-relaxed" data-id="element-272">
                Una presentación que no parece catering industrial — parece
                hospitalidad real, cuidada por manos artesanas.
              </p>
            </div>
          </StaggerItem>
        </StaggerContainer>

        <FadeIn delay={0.4} className="mt-16 text-center max-w-3xl mx-auto" data-id="element-273">
          <p className="text-lg text-brown-medium leading-relaxed" data-id="element-274">
            Cuando la comida tiene identidad propia, cuando cada pieza fue hecha
            a mano con un criterio visual claro, la mesa deja de ser "el buffet"
            y se convierte en el centro del evento. Sus invitados no solo comen.
            Preguntan. Comentan. Sacan fotos. Y usted recibe el crédito que
            merece por haber cuidado cada detalle.
          </p>
        </FadeIn>
      </div>
    </section>;
}